import React from "react";
import PolymatchResults from "./PolymatchResults";

const PolymatchResults_Science = () => {
  // Pass Science competition data to the results page
  return <PolymatchResults 
    competition="science" 
    competitionHeading="Science Competition"
    year="2025"
  />;
};

export default PolymatchResults_Science;
